import { render, staticRenderFns } from "./DeleteSingleSenderId.vue?vue&type=template&id=c6c98034&"
import script from "./DeleteSingleSenderId.vue?vue&type=script&lang=js&"
export * from "./DeleteSingleSenderId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports